<template>
    <div>
        <v-text-field @blur="onBlur"
                      @keydown.enter="onLocaleTimeChanged"
                      @keydown="onKeyDown($event)"
                      v-model="localeTime"
                      :label="label"
                      :rules="timeRules"
                      v-bind="$attrs"
        >
            <template v-slot:append>
                <slot name="append"></slot>
            </template>
        </v-text-field>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop, Watch, Emit} from "vue-property-decorator";
import TimeFormatter from "../services/timeFormatter";

@Component
export default class TimeField extends Vue {
    @Prop({type: String}) label: string;
    @Prop({type: String}) value: string;
    @Prop() rules: any[];

    localeTime: string = null;
    isoTime: string = null;
    isValidIso: boolean = true;
    lastTime: string = null;

    get validTime() {
        if (this.localeTime == null || this.localeTime === '')
            return true;
        return this.isValidIso || this.$vopsui.labels.invalidTime();
    }

    get timeRules() {
        return [this.validTime].concat(this.rules || []);
    }

    @Emit()
    private input(value: string) {
    }


    @Emit() blur () {}

    onBlur() {
        this.onLocaleTimeChanged();
        this.blur();
    }

    @Watch("value", {immediate: true})
    private onValueChange(isoValue: string) {
        if (this.updateIsoTime(isoValue)) {
            this.input(this.isoTime);
            this.updateLocaleTime(isoValue);
        }
    }

    private updateIsoTime(localeTime: string): boolean {
        let isoTime = TimeFormatter.toIsoString(localeTime);
        if (isoTime == null && localeTime != null) {
            isoTime = localeTime;
            this.isValidIso = false;
        } else {
            this.isValidIso = true;
        }

        const changed = isoTime !== this.isoTime;
        this.isoTime = isoTime;
        return changed;
    }

    private updateLocaleTime(isoTime: string): boolean {
        if (!this.isValidIso)
            return false;
        const localeTime = TimeFormatter.toLocaleString(isoTime);
        const changed = localeTime !== this.localeTime;
        this.localeTime = localeTime;
        return changed;
    }

    onKeyDown($event: KeyboardEvent) {
        if ($event.key == "Enter")
            return;

        this.isValidIso = true;
    }

    onLocaleTimeChanged() {
        if (this.updateIsoTime(this.localeTime) || this.lastTime !== this.localeTime) {
            this.lastTime = this.localeTime;
            this.input(this.isoTime);
            this.updateLocaleTime(this.isoTime);
        }
    }
}
</script>